import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import { useNavigate, matchRoutes, useLocation } from 'react-router-dom';

import {
  styled,
} from '@mui/material';

import {
  AppBarTitle, Button, KeyIcon, Stack, Tooltip,
} from '@datanomik/commons-ui';

import { ArrowLeftLine } from '@datanomik/commons-ui/icons';

import { APP_ROUTES } from '@/assets/MenuItems';

import { styles } from './styles';

const BreadcrumbsRaw = ({ className }) => {
  const location = useLocation();
  const menuMatchRoutes = matchRoutes(APP_ROUTES, location);

  if (!menuMatchRoutes) return null;

  const { length, 1: parentRoute, [length - 1]: routeItem } = menuMatchRoutes;

  let route = routeItem?.route;
  if (parentRoute && !parentRoute.route.element) {
    route = parentRoute.route;
  }

  if (routeItem?.route.hiddenPageTitle) return null;

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const showBack = !routeItem?.route?.hideBackButton;

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="14px"
    >
      {showBack && (
        <Tooltip title={t('Back')}>
          <Button
            color="black"
            variant="text"
            onClick={handleGoBack}
            startIcon={<ArrowLeftLine />}
          />
        </Tooltip>
      )}
      <AppBarTitle
        className={className}
        startAdornment={(
          <KeyIcon size="large">
            {route?.icon}
          </KeyIcon>
        )}
        text={t(route?.label)}
        subText={t(route?.description)}
      />
    </Stack>
  );
};

const Breadcrumbs = styled(BreadcrumbsRaw)(styles);

BreadcrumbsRaw.propTypes = {
  className: PropTypes.string,
};

Breadcrumbs.propTypes = BreadcrumbsRaw.propTypes;

export default Breadcrumbs;
